import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiConstant } from '../../types';
import { API_TOKEN, } from '../types';

const TRANSACTION_NAME = environment.elasticAPM.transactionName;

@Injectable()
export class SimulationService {
    simulationUrl = `${this.apiConstants.endpoint}/Simulation`;

    private getAllorgSub$ = new Subject<any>();
    private getSub$ = new Subject<any>();
    private createSub$ = new Subject<any>();
    private updateSub$ = new Subject<any>();
    private startSub$ = new Subject<any>();
    private getPrepareInfoSub$ = new Subject<any>();
    private createSimulationTempSub$ = new Subject<any>();
    private leaveSimulation$ = new Subject<any>();

    constructor(
        @Inject(API_TOKEN) private apiConstants: ApiConstant,
        private httpClient: HttpClient,
    ) { }

    getListSimulation(filterSimulation: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get list simulation' });
        return this.httpClient
            .post(`${this.simulationUrl}/Gets`, filterSimulation, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getAllorgSub$.next(result);
                    }
                })
            );
    }

    get(simulationId: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get simulation by id' });
        return this.httpClient
            .post(`${this.simulationUrl}/Get?id=${simulationId}`, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getSub$.next(result);
                    }
                })
            );
    }

    create(objCreate: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Create simulation' });
        return this.httpClient
            .post(`${this.simulationUrl}/CreateSimulations`, objCreate, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.createSub$.next(result);
                    }
                })
            );
    }

    update(objCreate: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Create simulation' });
        return this.httpClient
            .post(`${this.simulationUrl}/UpdateSimulations`, objCreate, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.updateSub$.next(result);
                    }
                })
            );
    }

    start(objStart: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Start simulation' });
        return this.httpClient
            .post(`${this.simulationUrl}/StartSimulations`, objStart, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.startSub$.next(result);
                    }
                })
            );
    }

    getPrepareInfo(id: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'GetPrepareInfo' });
        return this.httpClient
            .post(`${this.apiConstants.endpoint}/Simulation/GetPrepareInfo`, { simulationId: id }, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getPrepareInfoSub$.next(result);
                    }
                })
            );
    }

    createSimulationTemp(data: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiConstants.endpoint}/Simulation/CreateSimulationTemp`, data)
            .pipe(
                tap(result => {
                    if (result) {
                        this.createSimulationTempSub$.next(result);
                    }
                })
            );
    }

    leaveSimulations(data: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'leave Simulations' });
        return this.httpClient
            .post(`${this.apiConstants.endpoint}/Simulation/LeaveSimulations`, data, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.leaveSimulation$.next(result);
                    }
                })
            );
    }

}
